import { Button } from "../buttons";
import React, { useState } from "react";
import { extractSameDayExcelFile } from "../../../services/import";
import { Blocker } from "../misc";
import { LoadingAnimation } from "../loading";
import { wait } from "@testing-library/user-event/dist/utils";

import "../../../styles/groups/import.css";

export function ExcelFileImporter({ onExtract }) {

    const ref = React.createRef();
    const [ extracting, setExtracting ] = useState(false);
    const [ canImport, setCanImport ] = useState(false);
    const [ error, setError ] = useState(null);

    const onChange = (event) => {
        setCanImport(event.target.files && event.target.files.length === 1);
        setError(null);
    };

    const onError = (error) => {
        if(ref.current) ref.current.value = "";
        setError(error);
    };

    const loadFile = async () => {
        setError(null);
        setExtracting(true);

        /** @type {HTMLInputElement} */
        const input = ref.current;

        const file = input.files[0];
        await wait(500);

        try {
            const extracted = await extractSameDayExcelFile(file);
            if(extracted.ok) onExtract(extracted.data);
            else onError(extracted.error);
        } catch(e) {
            console.log(e);
            onError("An error occured. Try again.");
        }

        setExtracting(false);
    };

    return <div className="excel-import">
        <label>SELECT A FILE (.xls, .xlsx)</label><br /> 
        { error ? <div className="error-strip">{error}</div> : "" }
        <input type="file" ref={ref} className="input" onChange={onChange} />
        <Button color="blue" onClick={loadFile} disabled={!canImport}>IMPORT</Button>
        

        <Blocker active={extracting}><center><LoadingAnimation /> Extracting data...</center></Blocker>
    </div>;
}